import React, {Component} from 'react';

class ExpandButton extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange() {
        this.props.onStateChange()
    }
    render() {

        var buttonText;

        if (!this.props.clicked) {
            buttonText = `<i class="fas fa-sort-down"></i> Show all
                <strong> ${this.props.length} reports </strong> <i class="fas fa-sort-down"></i>`;
        } else {
            buttonText = `<i class="fas fa-sort-up"></i> Collapse <i class="fas fa-sort-up"></i>`;
        }

        return (
            <div className="buttonwrap" onClick={this.handleChange}>
                <div className="showMoreButton" dangerouslySetInnerHTML={{
                    __html: buttonText
                }}></div>
            </div>
        )
    }
}

export default ExpandButton



// WEBPACK FOOTER //
// ./src/components/tables/ExpandButton.js